module.exports = __webpack_public_path__ + "img/MemeETC (11).d3903d6f.jpeg";